import { AUTHORIZATION_HEADER } from '../../../../../../src/authorization';
import { send } from '../../../../../../src/network';

type Params = {
  customerId: number;
  data: {
    periodicity: number;
    product: number;
  }[];
};

export async function patchCustomerPeriodicities({ customerId, data }: Params) {
  return await send<
    {
      periodicity: number;
      product: number;
    }[]
  >({
    path: `/api/v2/customers/${customerId}/periodicities/`,
    method: 'PATCH',
    body: data,
    headers: new Headers({
      AUTHORIZATION: AUTHORIZATION_HEADER,
    }),
  });
}
